import { render, staticRenderFns } from "./UpdateBlockUserModal.vue?vue&type=template&id=c8e0374e"
import script from "./UpdateBlockUserModal.vue?vue&type=script&lang=js"
export * from "./UpdateBlockUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports